import SuperAdminDashboard from "./SuperAdminDashboard.container";

export default SuperAdminDashboard;
